import script from "./RealtimeActivityFeedPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./RealtimeActivityFeedPanel.vue?vue&type=script&setup=true&lang=js"

import "./RealtimeActivityFeedPanel.vue?vue&type=style&index=0&id=4cce9ad0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cce9ad0"]])

export default __exports__